// https://codepen.io/AlvaroFelipe/pen/bWWXpY

export default () => {
  // Get video code
  const getYouTubeVideoCode = (url) => {
    let inicio = url.indexOf('?') + 3,
      final = url.indexOf('&', inicio),
      code = final !== -1 ? url.slice(inicio, final) : url.slice(inicio),
      params = url.slice(final);
    return final !== -1 ? `${code}?${params}&` : `${code}?`;
  };

  // Create the modal
  const printYouTubeModal = (videoCode) => {
    let modal = document.createElement('div');
    modal.id = 'modalYouTube';
    modal.classList.add('youtubeModal');
    modal.innerHTML = `
        <div class="youtubeModal-content">
            <div id="closeModal" class="youtubeModal-close">X</div>
            <div class="youtubeModal-video">
                <iframe src="https://www.youtube.com/embed/${videoCode}?autoplay=1&showinfo=0" frameborder="0" allowfullscreen> </iframe>
            <div>
        </div>`;
    document.body.appendChild(modal);
    closeModal(modal);
  };

  // Close the modal
  const closeModal = (modal) => {
    document.getElementById('closeModal').addEventListener('click', () => {
      document.body.removeChild(modal);
    });
    window.addEventListener('keyup', (e) => {
      if (e.key === 'Escape') {
        document.getElementById('closeModal').click();
      }
    });
  };

  // Open modal
  const openYouTubeModal = (selector) => {
    let linksElements = [...document.querySelectorAll(selector)],
      links = linksElements.map((link) => link.href);
    linksElements.forEach((el, i) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        printYouTubeModal(getYouTubeVideoCode(links[i]));
      });
    });
  };

  openYouTubeModal('.modal-youtube');
};
